/**
 * Preset inputs for explorable sample reports — same engine as personal reports.
 * Target year for Personal Year / cycle context is fixed to SAMPLE_TARGET_YEAR (2026).
 */

export const SAMPLE_TARGET_YEAR = 2026;

export const SAMPLE_PERSONA_IDS = {
  POE: 'edgar-allan-poe',
  CURIE: 'marie-curie',
};

/**
 * Birth names and dates are historical; numerology is symbolic, not biographical verdict.
 */
export const SAMPLE_PERSONAS = {
  [SAMPLE_PERSONA_IDS.POE]: {
    id: SAMPLE_PERSONA_IDS.POE,
    displayName: 'Edgar Allan Poe',
    firstName: 'Edgar',
    fullBirthName: 'Edgar Allan Poe',
    dateOfBirth: '1809-01-19',
    shortBio: 'American writer and critic (1809–1849). Sample for pattern exploration only.',
  },
  [SAMPLE_PERSONA_IDS.CURIE]: {
    id: SAMPLE_PERSONA_IDS.CURIE,
    displayName: 'Marie Curie',
    firstName: 'Maria',
    /** Birth-record style name for letter-based calculations */
    fullBirthName: 'Maria Salomea Sklodowska',
    dateOfBirth: '1867-11-07',
    shortBio: 'Physicist and chemist (1867–1934). Sample for pattern exploration only.',
  },
};

export function getSamplePersonaInput(personaId) {
  const p = SAMPLE_PERSONAS[personaId];
  if (!p) return null;
  return {
    firstName: p.firstName,
    fullBirthName: p.fullBirthName,
    dateOfBirth: p.dateOfBirth,
    currentName: '',
    targetYear: SAMPLE_TARGET_YEAR,
    targetCalendarMonth: undefined,
    focusQuestion: '',
    preferredLifeArea: '',
    sampleMode: true,
    samplePersonaId: p.id,
    profileKind: undefined,
  };
}
